import { render } from "./KupGre.vue?vue&type=template&id=fbc1c12c&scoped=true"
import script from "./KupGre.vue?vue&type=script&lang=js"
export * from "./KupGre.vue?vue&type=script&lang=js"

import "./KupGre.vue?vue&type=style&index=0&id=fbc1c12c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbc1c12c"]])

export default __exports__